import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { DATETIME_FORMAT_TIME } from '../../utils/helpers/CommonHelper';
import { isUndefined } from 'lodash';

export const eduCourseDatesApi = createApi({
  reducerPath: 'eduCourseDatesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getEduCourseDates: builder.query({
      query: (courseId) => ({
        url: urls.eduCourseDates(courseId),
      }),
    }),
    getEduCourseDate: builder.query({
      query: (courseId) => ({
        url: urls.eduCourseDateDetail(courseId),
      }),
    }),
    getMyEduCourseDates: builder.query({
      query: () => ({
        url: `${urls.eduCourseDatesList}`,
        method: 'GET',
      }),
    }),
    getEduCourseDateParticipants: builder.query({
      query: (dateId) => ({
        url: urls.eduCourseDateParticipants(dateId),
        method: 'GET',
      }),
    }),
    saveEduCourseDate: builder.mutation({
      query: ({ id, courseId, data }) => {
        const [timeFrom, timeTo] = data.time;
        const [dateFrom, dateTo] = data.dates;

        const formData = {
          edu_course_id: courseId,
          place: data.place,
          capacity: data.capacity,
          time:
            timeFrom.format(DATETIME_FORMAT_TIME) +
            ' - ' +
            timeTo.format(DATETIME_FORMAT_TIME),
          date_from: dateFrom.format(),
          date_to: dateTo.format(),
          date_registration_closed: data.date_registration_closed.format(),
        };

        if (!isUndefined(id)) {
          return {
            url: urls.eduCourseDateDetail(id),
            method: 'PATCH',
            data: formData,
          };
        }

        return {
          url: urls.eduCourseDateStore,
          method: 'POST',
          data: formData,
        };
      },
    }),
    cancelEduCourseDate: builder.mutation({
      query: (dateId) => ({
        url: urls.eduCourseDateCancel(dateId),
        method: 'PATCH',
      }),
    }),
    enrollToEduCourseDate: builder.mutation({
      query: (dateId) => ({
        url: urls.eduCourseDateEnroll(dateId),
        method: 'PATCH',
      }),
    }),
    unenrollFromEduCourseDate: builder.mutation({
      query: ({ dateId, participantId, byLecturer = false }) => ({
        url: `${urls.eduCourseDateUnenroll(dateId, participantId)}?byLecturer=${byLecturer ? '1' : '0'}`,
        method: 'PATCH',
      }),
    }),
    deleteEduCourseDate: builder.mutation({
      query: (dateId) => ({
        url: urls.eduCourseDateDetail(dateId),
        method: 'DELETE',
      }),
    }),
    sendEduCourseDateMessage: builder.mutation({
      query: ({ dateId, subject, body }) => ({
        url: urls.eduCourseDateSendMessage(dateId),
        method: 'PATCH',
        data: { subject, body },
      }),
    }),
  }),
});

export const {
  useGetEduCourseDatesQuery,
  useGetEduCourseDateQuery,
  useGetMyEduCourseDatesQuery,
  useGetEduCourseDateParticipantsQuery,
  useSaveEduCourseDateMutation,
  useCancelEduCourseDateMutation,
  useEnrollToEduCourseDateMutation,
  useUnenrollFromEduCourseDateMutation,
  useDeleteEduCourseDateMutation,
  useSendEduCourseDateMessageMutation,
} = eduCourseDatesApi;
